import WidgetIdSelector from './WidgetIdSelector';

export * from './types';

export default WidgetIdSelector;
